/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
import { RouteUrl } from './routeUrl';

interface Props {
  routeParams: Record<string, string>;
  searchParams: URLSearchParams;
  location: Location | null;
  pathname: string;
}

type Observer = (props: Props) => Promise<void>;

export const routeObserver = routeObserverFn();

function routeObserverFn() {
  let exitObserver: Observer = async (_props: Props) => {};

  /*
    Add xyzEnter and xyzExit functions **AS NEEDED**
  */
  const observables = {
    eventSearchEnter: async (_props: Props) => {},
    linkAnalysisEnter: async (_props: Props) => {},
    riskScoresEnter: async (_props: Props) => {},
  };

  return {
    routeChanged, // via useRouteObserver
    observeEventSearchEnter,
    observeLinkAnalysisEnter,
    observeRiskScoresEnter,
  };

  async function routeChanged(props: Props) {
    await exitObserver(props);
    exitObserver = async (_props: Props) => {};
    if (props.pathname === RouteUrl.eventsSearch) {
      await observables.eventSearchEnter(props);
      // **AS NEEDED** exitObserver = observables.eventSearchExit;
    } else if (props.pathname === RouteUrl.linkAnalysis) {
      await observables.linkAnalysisEnter(props);
    } else if (props.pathname === RouteUrl.riskScores) {
      await observables.riskScoresEnter(props);
    }
  }

  function observeEventSearchEnter(observer: Observer) {
    observables.eventSearchEnter = observer;
  }
  function observeLinkAnalysisEnter(observer: Observer) {
    observables.linkAnalysisEnter = observer;
  }
  function observeRiskScoresEnter(observer: Observer) {
    observables.riskScoresEnter = observer;
  }
}
